module.exports = __webpack_public_path__ + "img/83ne.a0bfd3dc.svg";